import Tracker from '@openreplay/tracker';

const openReplayTracker = new Tracker({
  projectKey: 'gmYGn5Pn5r4FgHJvyjSq',
  ingestPoint: 'https://openreplay.prod.tradetalk.us/ingest',
});

export default openReplayTracker;
